import _ from "lodash";
import React, { useState } from "react";
import PrimaryButton from "../Buttons/PrimaryButton";
import { NumberInput, TextInput } from "../Inputs";
import PrimaryTable from "../Tables/PrimaryTable";
import ModalWrapper from "./ModalWrapper";

function EnumEntityModal({ isOpen, onClose, onAddEnum }) {
  const [enumTableName, setEnumTableName] = useState("");
  const [enumName, setEnumName] = useState("");
  const [enumValue, setEnumValue] = useState(0);
  const [enumNameList, setEnumNameList] = useState([]);
  const [enumValueList, setEnumValueList] = useState([]);
  const [formattedEnum, setFormattedEnum] = useState([]);
  const [enumTableNameList, setEnumTableNameList] = useState([]);

  const addRow = () => {
    if (
      enumTableName.trim() !== "" &&
      enumName.trim() !== "" &&
      !_.includes(enumNameList, enumName) &&
      !_.includes(enumValueList, enumValue)
    ) {
      setEnumNameList([...enumNameList, enumName, ", "]);
      setEnumValueList([...enumValueList, enumValue, ", "]);
      setFormattedEnum([
        ...formattedEnum,
        {
          name: enumName,
          value: enumValue,
          property: "Name",
        },
      ]);

      setEnumName("");
      setEnumValue((x) => x + 1);
    }
  };

  const addEnumToEntitiesList = () => {
    if (!_.includes(enumTableNameList, enumTableName)) {
      onAddEnum(enumTableName, formattedEnum);
      setEnumTableNameList([...enumTableNameList, enumTableName]);
      setEnumNameList([]);
      setEnumValueList([]);
      setEnumTableName("");
      setFormattedEnum([]);
      setEnumValue(0);
    }
  };

  return (
    <ModalWrapper open={isOpen} setOpen={onClose}>
      <div className="w-[85vw] lg:w-[35vw]">
        <div className="pb-4 text-center flex items-center flex-col"></div>

        <div className="pb-8 mx-6 text-center text-sm text-gray-500">
          Add your entity information.
        </div>

        <div className="mb-8">
          <TextInput
            label="Table Name"
            placeholder="Enter Table Name (singular, PascalCase)"
            value={enumTableName}
            onChange={(e) => setEnumTableName(e.target.value)}
          />
        </div>

        <div className="mb-8">
          <TextInput
            label="Item Name"
            placeholder="Enter Item Name"
            value={enumName}
            onChange={(e) => setEnumName(e.target.value)}
          />
        </div>

        <div className="mb-8">
          <NumberInput
            label="Item Value"
            placeholder="Enter Item Value"
            value={enumValue}
            onChange={(e) => setEnumValue(e.target.valueAsNumber)}
          />
        </div>

        <div className="mt-3">
          <PrimaryButton
            text="Add enum value"
            onClick={addRow}
            disabled={
              enumTableName.trim() === "" ||
              enumName.trim() === "" ||
              _.includes(enumNameList, enumName) ||
              _.includes(enumValueList, enumValue)
            }
          />
          <div className="my-4 p-4 bg-gray-200 rounded-lg">
            <h3 className="font-bold text-xl mb-3">{enumTableName}</h3>

            <PrimaryTable
              paginatorHidden="true"
              header={
                <PrimaryTable.Header>
                  <PrimaryTable.HeaderColumn display="Name" />
                  <PrimaryTable.HeaderColumn display="Value" />
                </PrimaryTable.Header>
              }
            >
              {_.map(formattedEnum, (x) => (
                <PrimaryTable.Row key={`${x.Value}`}>
                  <PrimaryTable.Cell>{x.name}</PrimaryTable.Cell>
                  <PrimaryTable.Cell>{x.value}</PrimaryTable.Cell>
                </PrimaryTable.Row>
              ))}
            </PrimaryTable>
          </div>
          <div className="py-2" />
          <PrimaryButton
            text="Add Entity to Project"
            onClick={addEnumToEntitiesList}
            disabled={_.includes(enumTableNameList, enumTableName)}
          />
        </div>
      </div>
    </ModalWrapper>
  );
}

export default EnumEntityModal;
